module.exports = __webpack_public_path__ + "static/media/5.1bc7aa0a.JPG";